import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=b4a1b68a&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=ts&"
export * from "./edit.vue?vue&type=script&lang=ts&"
import style0 from "./edit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./edit.vue?vue&type=style&index=1&id=b4a1b68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a1b68a",
  null
  
)

export default component.exports